export const INTERVIEW_MEDIA_CONFIG = {
  video: {
    width: { ideal: 1280 },
    height: { ideal: 720 }
  },
  audio: true
} as const;
